"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextareaAutoSize = void 0;
const react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
const styled_components_1 = __importDefault(require("styled-components"));
// Mostly unstyled, but a small addition for backwards compatablity
/**
 * @deprecated Use `Ds.Textarea` with `autoResize` props instead
 */
exports.StyledTextareaAutoSize = (0, styled_components_1.default)(react_textarea_autosize_1.default) `
    resize: none;
`;
//# sourceMappingURL=TextareaAutosize.styles.js.map